(function () {
    "use strict";

    // @ngInject
    function InviteControllerCtor($scope, $injector, $timeout, $stateParams, $q, Gon, _, $, $translate, ModelFactory, moment,
                                  UsersManager, MemberReferralsManager, ReferralService, AnalyticsService,
                                  ModalService, AbTestService, Enums, UserService, OnboardingService, UIUtils,
                                  $sce, ngToast, EventService, UiPersistenceService, DeviceService, WebsocketHelperService, DoodleService) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'InviteControllerCtor';
        this.currentUser = UsersManager.getCurrUser();
        this.$translate = $translate;

        var analyticParam = {};
        var tabTitle = this.$state.current.url;
        if (tabTitle === "/referrals") {
            analyticParam.source = "dashboard";
        } else if (tabTitle === "/track") {
            analyticParam.source = "tracking";
        } else if (tabTitle === "/partners") {
            analyticParam.source = "discounts";
        }

        AnalyticsService.trackPageView(this, 'referrals', analyticParam);
        this.WebsocketHelperService = WebsocketHelperService;
        this.DeviceService = DeviceService;
        this.$q = $q;
        this.$ = $;
        this.ReferralService = ReferralService;
        this.OnboardingService = OnboardingService;
        this.$sce = $sce;
        this.ngToast = ngToast;
        this.UserService = UserService;
        this.UiPersistenceService = UiPersistenceService;
        this.userList = [];
        this.copyBtnText = 'FREQUENT_BUTTONS._COPY_';
        this.$timeout = $timeout;
        this.sendingInvites = false;
        this.AnalyticsService = AnalyticsService;
        this.ModalService = ModalService;
        this.facebookAppId = Gon.facebook_app_id;
        this.emails = [];
        this.MemberReferralsManager = MemberReferralsManager;
        this._ = _;
        this.sendingReminders = [];
        this.suggestionsInvites = [];
        this.ModelFactory = ModelFactory;
        this.moment = moment;
        this.AbTestService = AbTestService;
        this.Enums = Enums;
        this.UsersManager = UsersManager;
        this.googleContactsIntegrationActive = this.currentUser.isGoogleIntegrationActive('contacts');
        this.referralSuggestionsBlacklist = UiPersistenceService.getUiPersistence(UiPersistenceService.keys.referralSuggestionsBlacklist,
            {userEmails: []});
        this.DoodleService = DoodleService;
        this.UIUtils = UIUtils;

        this.AbTestService.convertAbTest(this.Enums.ABTests.referralAwarenessSubject); //initiated on the server side.
        this.AbTestService.convertAbTest(this.Enums.ABTests.referralAwarenessContent); //initiated on the server side.
        this.AbTestService.convertAbTest(this.Enums.ABTests.referralAwarenessLandingPage); //initiated on the server side.
        this.AbTestService.convertAbTest(this.Enums.ABTests.referralAwarenessFinal); //initiated on the server side.
        this.WebsocketHelperService.registerToRoom(this.currentUser._id + '.referral_suggestions', this.onReceivedReferralSuggestions.bind(this));
        this.showEarnings = false;

        const dayOfTheWeek = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'][new Date().getDay()];

        const getSuggestionsHeading = isInExperiment => {
            return isInExperiment
                ? 'Waiting for your referral'
                : this.$translate.instant('REFERRAL_DASHBOARD._SUGGESTED_FOR_YOU_');
        }

        const getDefaultPersonalInviteMessage = (day, firstName) => {
            // The ${ '' } are only here to preserve the indentation
            // Otherwise, template strings include the indentation in the view
            return `Hey, hope your ${day} is going well. I’ve been using HoneyBook\
${    ''    } to help book clients more efficiently and stay organized and thought you\
${    ''    } might like it too.

${    ''    }Thanks,
${    ''    }${firstName}`;
        }

        this.defaultPersonalInviteMessage = getDefaultPersonalInviteMessage(
            dayOfTheWeek,
            this.currentUser.first_name);

        const campaignPromise = this.ReferralService.getCampaignDetails(this.currentUser);
        const variantPromise = this.AbTestService.getAbTestVariation(this.Enums.ABTests.editReferralEmail);

        Promise.all([campaignPromise, variantPromise]).then( values => {
            const campaignDetails = values[0];
            const variant         = values[1];

            this.showEditReferralEmail = (String(variant) === 'true'); // Cast AB test to Boolean
            this.showReferByEmail = campaignDetails.campaign_uid !== '29983';

            this.campaignDetails          = campaignDetails;
            this.suggestionsHeading       = getSuggestionsHeading(this.showEditReferralEmail);
            this.suggestionsStackingOrder = this.showEditReferralEmail && 'referrals-content__ab-test-wrapper--reversed'
            this.referralEmailMessage     = campaignDetails._personal_invite_message || this.defaultPersonalInviteMessage;

            this.personalMessageLinkText = `💰 For ${campaignDetails.discount_amount_text} off your first year, use my`

        }).catch( error => console.error(error) );

        this.referralsTabs = [
            {
                name: "Invited",
                tabTitle: "Referred",
                showMore: false,
                tooltip: "Your invite was sent successfully, but hasn’t been used to start a trial yet.",
                sumText: " is within reach"
            },
            {
                name: "signed_up",
                tabTitle: "Started trial",
                showMore: false,
                tooltip: "Your referral link has been used to start a free trial on HoneyBook. Be sure to share your experience as friends try it out.",
                sumText: " is at your fingertips"
            },
            {
                name: "Joined",
                tabTitle: "Joined",
                showMore: false,
                tooltip: "Hooray! Your referral link worked its magic and helped a friend subscribe to HoneyBook!",
                sumText: " is in your pocket"
            }
        ];

        this.activeTab = this.referralsTabs[0].name;

        this.tagfocus = false;

        this.benefits = [
        {
            img: "https://res.cloudinary.com/honeybook/image/upload/f_auto,q_auto/v1536101976/app/greetabl.png",
            title: "Greetabl",
            description: "Message: 25% off your first Greetabl: The #1 Client Gift for Creative Professionals",
            code: "HBPARTNERS1"
        },
        // Hidden temporarily
        // --- Martha request; will restore soon
        // {
        //     img: "//res.cloudinary.com/honeybook/image/upload/v1491434662/membership-benefits/Boxfox_logo.png",
        //     title: "BOXFOX",
        //     description: "Offer: 15% off personalized gift boxes",
        //     code: "15Honeybook2018"
        // },
        {
            img: "//res.cloudinary.com/honeybook/image/upload/v1491434663/membership-benefits/Track_logo.png",
            title: "Track",
            description: "Offer: One free year of tax withholding from Track. (Normally $10/month.)",
            link: "https://www.track.tax/?partner=honeybook&utm_medium=honeybook"
        }, {
            img: "//res.cloudinary.com/honeybook/image/upload/v1509411298/membership-benefits/Showit-Logo-Dark-400.png",
            title: "Showit",
            description: "Offer: 10% off first year of Showit",
            link: "https://store.showit.co/dc/honeybook"
        }, {
            img: "//res.cloudinary.com/honeybook/image/upload/v1502909747/app/Matchology-logo.png",
            title: "Matchology",
            description: "Offer: 15% off subscription to submission platform for the top wedding blogs",
            code: "HB15OFF"
        }, {
            img: "//res.cloudinary.com/honeybook/image/upload/v1502909797/app/Gusto-logo.png",
            title: "Gusto",
            description: "Offer: First three months free of payroll for small businesses",
            link: "https://go.gusto.com/honeybook"
        }, {
            img: "//res.cloudinary.com/honeybook/image/upload/v1491434663/membership-benefits/Expensify_logo.png",
            title: "Expensify",
            description: "Offer: First three months free of expense importing, tracking and reimbursing",
            link: "https://www.expensify.com/m/?promoCode=honeybook&utm_campaign=receiptburner_march_2017&utm_medium=website&utm_source=tech_honeybook"
        }, {
            img: "//res.cloudinary.com/honeybook/image/upload/v1491434662/membership-benefits/ShootProof_logo.png",
            title: "ShootProof",
            description: "Offer: 25% off any yearly online proofing and client gallery plan",
            code: "HONEYBOOK"
        }, {
            img: "https://res.cloudinary.com/honeybook/image/upload/v1491439118/membership-benefits/Zenfolio_logo.png",
            title: "Zenfolio",
            description: "Offer: 30% off any professional video and photo hosting and storefront account",
            code: "ZENHONEY"
        }, {
            img: "//res.cloudinary.com/honeybook/image/upload/v1491434663/membership-benefits/CloudSpot_logo.png",
            title: "CloudSpot",
            description: "Offer: 10% off any photo gallery storage and sharing plan",
            code: "Honeybook"
        }, {
            img: "https://res.cloudinary.com/honeybook/image/upload/v1493223706/membership-benefits/galler.ee.png",
            title: "Galler.ee",
            description: "Offer: $10 gift card to use on any purchase in the Galler.ee store",
            code: "GIVEME10"
        }, {
            img: "https://res.cloudinary.com/honeybook/image/upload/f_auto,q_auto,fl_lossy/v1552923205/membership-benefits/TCSLogo.png",
            title: "The Contract Shop",
            description: "Offer: 15% off legal templates specifically designed for freelancers and small business owners (no minimum spend)",
            code: "HONEYBOOK"
         }

        ];

        this.referrals = this.ModelFactory.newCollectionByModelName('MemberReferralModel');

        this.loadingReferrals = true;
        this.ReferralService.getUserReferrals()
            .then(function success(referrals) {
                this.referrals = referrals;
            }.bind(this))
            .finally(function done() {
                this.loadingReferrals = false;
            }.bind(this));

        this.loadingReferralStats = true;
        this.ReferralService.getUserReferralStats()
            .then(function success(stats){
                this.referralStats = stats;
            }.bind(this))
            .finally(function done() {
                this.loadingReferralStats = false;
            }.bind(this));

        this.loadGoogleContactsSuggestions = function loadGoogleContactsSuggestions($query) {
            var defer = this.$q.defer();
            if (this.googleContactsIntegrationActive) {
                this.UserService.searchGoogleContacts($query, null, null, true)
                    .then(function success(contacts) {
                        var result = this._.map(contacts.contacts, function (contact) {
                            return {name: contact.user.full_name, text: contact.user.email};
                        });
                        defer.resolve(result);
                    }.bind(this))
                    .catch(function failure(resp) {
                        if (this._.contains(['HBGoogleTokenRevokedError', 'HBGoogleIntegrationError', 'HBGoogleIntegrationMissingError'], resp.data.error_type)) {
                            this.UsersManager.getGoogleIntegrations();
                        }
                        defer.resolve([]);
                    }.bind(this));
            } else {
                defer.resolve([]);
            }

            return defer.promise;
        };

        this.getReferralSuggestions();
        $scope.$on('$destroy', function () {
            this.WebsocketHelperService.unregisterFromRoom(this.currentUser._id + '.referral_suggestions');
        }.bind(this));
    }

    Controllers.InviteController = Class(Controllers.BaseController, {
            constructor: InviteControllerCtor,

            inviteUsers: function inviteUsers(form) {
                var params = {source: 'email', count: this.emails.length};

                this.AnalyticsService.trackClick(
                    this,
                    this.AnalyticsService.analytics_events.referral_link_shared,
                    params
                );

                this.$timeout(function () {

                    if (form.$valid) {
                        this.sendingInvites = true;
                        this.convertReferralCTAAbTest();

                        this.AbTestService.convertAbTest(this.Enums.ABTests.editReferralEmail)

                        this.ReferralService.referUsersByEmail(
                            this.emails.map(emailTag => emailTag.text),
                            this.referrals,
                            this.referralEmailMessage
                        ).then(
                            function success() {
                                this.emails = [];
                                form.$setPristine();
                                this.ModalService.openThankYouReferralModal();
                            }.bind(this)
                        ).finally(
                            function () {
                                this.sendingInvites = false;
                            }.bind(this)
                        );
                    }

                }.bind(this), 200);
            },

        getReferralSuggestions: function getReferralSuggestions() {
            this.MemberReferralsManager.getReferralSuggestions(this.currentUser, this.googleContactsIntegrationActive);
        },

            convertReferralCTAAbTest: function convertReferralCTAAbTest() {
                // leaving this function, since we might wanna do other abtests.
                this.AbTestService.convertAbTest(this.Enums.ABTests.referralAwarenessEmailSender);
            },

            copyBtnClicked: function copyBtnClicked() {
                var params = {source: 'copy'};
                this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.referral_link_shared, params);

                this.convertReferralCTAAbTest();
                this.copyBtnText = 'FREQUENT_BUTTONS._COPIED_';
                this.$timeout(function () {
                    this.copyBtnText = 'FREQUENT_BUTTONS._COPY_';
                }.bind(this), 3000);
            },

            onShareLinkClicked: function onShareLinkClicked($event) {
                $event.target.select();
            },

            onFacebookShareClick: function onFacebookShareClick() {
                var params = {source: 'facebook'};
                this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.referral_link_shared, params);

                this.convertReferralCTAAbTest();
            },

            onCouponClicked: function onCouponClicked(benefit) {
                benefit.showCode = true;
                var args = {
                    coupon_name: benefit.title
                };
                this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.my_benefits_partners_coupon_click, args);
            },

            removeSendReferralReminderToast: function removeSendReferralReminderToast() {
                this.ngToast.dismiss(this.referralToast);
            },

            sendReferralReminder: function sendReferralReminder(referral, index) {

                this.sendingReminders[index] = true;

                this.referralToastContent = '<i class="icon check-mark-icon icon-hb-nx-check-mark-circle-16"></i>\n' +
                    ' <button ng-click="inviteVm.removeSendReferralReminderToast()" type="button" class="close">\n' +
                    '                                <span class="icon icon-hb-nx-close-16"></span>\n' +
                    '                            </button>\n' +
                    '                            <span>' + (referral.status === "invited" ? "Reminder" : "Follow up") + ' sent to ' + referral.referred_user_email + '</span>';

                this.MemberReferralsManager.sendReferralReminder(this.currentUser, referral)
                    .finally(function done() {
                        this.sendingReminders[index] = false;
                        this.referralToast = this.ngToast.create({
                            content: this.$sce.trustAsHtml(this.referralToastContent),
                            className: 'referral-toast alert-success alert-dismissible',
                            dismissOnTimeout: false,
                            compileContent: this.$scope
                        });


                        this.$timeout(function () {

                            this.removeSendReferralReminderToast();
                        }.bind(this), 5000);


                    }.bind(this));
            },

            isReferralReminderEnabled: function isReferralReminderEnabled(referral) {
                var daysBetweenReminders = 2;
                var referralDate = this.moment(referral.created_at);
                var now = this.moment();

                return (referral.status !== 'member' &&
                    (now.diff(referralDate, 'days') >= daysBetweenReminders) && !this.isReminderSentLately(referral));
            },

            getReferralCreatedAtDays: function getReferralCreatedAtDays(referral) {

                var referralDate = this.moment(referral.created_at);
                var now = this.moment();

                return now.diff(referralDate, 'days');
            },

            getReferralCreatedText: function getReferralCreatedText(referral, referralTab) {
                if (referralTab.name === 'Invited') {
                    if (this.getReferralCreatedAtDays(referral) > 0) {
                        if (this.getReferralCreatedAtDays(referral) === 1) {
                            return 'Invited ' + this.getReferralCreatedAtDays(referral) + ' day ago'
                        } else {
                            return 'Invited ' + this.getReferralCreatedAtDays(referral) + ' days ago'
                        }
                    } else {
                        return 'Invited today'
                    }
                }
                else {
                    return referral.referred_user_email
                }
            },

            isReminderSentLately: function isReminderSentLately(referral) {
                var isReminderSentLately = false;
                var daysBetweenReminders = 2;
                var now = this.moment();
                if (referral.last_reminder_timestamp) {
                    var lastReminderDate = this.moment(referral.last_reminder_timestamp);

                    // at least 2 days need to have passed before you can send another reminder
                    isReminderSentLately = (now.diff(lastReminderDate, 'days') < daysBetweenReminders);
                }
                return isReminderSentLately;
            },

            getReminderSentDate: function getReminderSentDate(referral) {
                if (referral.last_reminder_timestamp) {
                    return referral.last_reminder_timestamp;
                } else {
                    return null;
                }
            },


            getReminderBtnDisplayTxt: function getReminderBtnDisplayTxt(referral, index) {
                var txt = '';
                if (referral.status === 'invited') {
                    txt = 'Send Reminder';
                    if (this.sendingReminders[index]) {
                        txt = 'Sending...';
                    } else if (!this.isReferralReminderEnabled(referral)) {
                        txt = 'Reminder sent';
                    }
                } else if (referral.status === 'signed_up') {
                    txt = 'Send follow up';
                    if (this.sendingReminders[index]) {
                        txt = 'Sending...';
                    } else if (!this.isReferralReminderEnabled(referral)) {
                        txt = 'follow up sent';
                    }
                }
                return txt;
            },

            connectToAGoogleAccount: function connectToAGoogleAccount(preferredGoogleAccountEmail) {
                this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.gmail_sync);

                if (this.currentUser.isGoogleIntegrationActive('contacts')) {
                    this.openGoogleContactsImport();
                } else {
                    this.UserService.connectToAGoogleAccount(preferredGoogleAccountEmail, 'contacts', 'referrals');
                }
            },

            openGoogleContactsImport: function openGoogleContactsImport() {
                this.convertReferralCTAAbTest();
                this.ModalService.openGoogleContactsModal(this.inviteContact.bind(this), 'Invite', false, false, 'referrals', 'invite users');
            },

            inviteContact: function inviteContact(contact) {
                this.ReferralService.referUsersByEmail([contact.user.email], this.referrals).then(
                    function success() {
                        contact.added = true;
                    }.bind(this));
            },

            countByStatus: function countByStatus(status) {

                return this._.size(this._.filter(this.referrals, function (referral) {
                    if (status === "Invited") {
                        return referral.status === "invited";
                    } else if (status === "Joined") {
                        return referral.status === "member";
                    } else if (status === "signed_up") {
                        return referral.status === "signed_up";
                    }
                }));
            },

            filterReferralByStatus: function filterReferralByStatus(activeTab) {
                return function (referral) {
                    if (activeTab === "Invited" && (referral.status === "invited")) {
                        return true;
                    } else if (activeTab === "signed_up" && (referral.status === "signed_up")) {
                        return true;
                    } else if (activeTab === "Joined" && (referral.status === "member")) {
                        return true;
                    } else {
                        return false;
                    }
                };

            },

            onReceivedReferralSuggestions: function onReceivedReferralSuggestions(json) {
                if (json && json.length > 0) {
                    var suggestions = JSON.parse(json).data;
                    if(suggestions) {
                        this.suggestions = this._.reject(suggestions, function (suggestion) {
                            return this._.contains(this.referralSuggestionsBlacklist.userEmails, suggestion.user.email);
                        }.bind(this));
                        var args = {
                            referral_suggestions_count: this.suggestions.length
                        };
                        this.AnalyticsService.trackLoad(this, this.AnalyticsService.analytics_events.referral_suggestions, args);

                        if (!this.DeviceService.isIpadScreenSizeOrSmaller() && !this.DeviceService.checkIfTouchDevice()) {
                            this.arrangeSuggestionCards();
                        }
                    }
                }
            },

            onSuggestionClicked: function onSuggestionClicked(referralSuggestion, index) {
                referralSuggestion.is_referred = true;
                this.convertReferralCTAAbTest();
                var params = {
                    source: 'suggestion',
                    suggestion_source: referralSuggestion.source,
                    referral_email: referralSuggestion.user.email
                };
                this.AnalyticsService.trackConfirm(this, this.AnalyticsService.analytics_events.referral_suggestions, params);
                this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.referral_link_shared, params);

                var referral = this.MemberReferralsManager.createReferral(this.currentUser.email, referralSuggestion.user.email, 'suggestion', 'invited', true);

                this.register(referral, 'success', function onSuccess() {
                    this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.referral_suggestions, params);
                    this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.referral_link_shared, params);
                    this.referrals.push(referral);
                }.bind(this));

                this.register(referral, 'error', function onError(resp) {
                    this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.referral_suggestions, resp, params);
                    this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.referral_link_shared, resp, params);
                }.bind(this));

                this.removeSuggestionCard(index);
            },

            onDismissSuggestion: function onDismissSuggestion(referralSuggestion, index) {
                referralSuggestion.is_dismissed = true;
                this.referralSuggestionsBlacklist.userEmails.push(referralSuggestion.user.email);
                this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.referralSuggestionsBlacklist, {userEmails: this.referralSuggestionsBlacklist.userEmails});

                var params = {
                    source: 'suggestion',
                    suggestion_source: referralSuggestion.source,
                    referral_email: referralSuggestion.user.email
                };
                this.AnalyticsService.trackCancel(this, this.AnalyticsService.analytics_events.referral_suggestions, params);
                this.removeSuggestionCard(index);
            },

            removeSuggestionCard: function removeSuggestionCard(index) {
                // use timeout to wait till animation ends
                this.$timeout(function () {
                    this.suggestions.splice(index, 1);
                    if (!this.DeviceService.isIpadScreenSizeOrSmaller() && !this.DeviceService.checkIfTouchDevice()) {
                        this.arrangeSuggestionCards();
                    }
                }.bind(this), 1000);
            },

            getSuggestionTitle: function getSuggestionTitle(suggestion) {
                return suggestion.user.full_name || suggestion.user.email;
            },

            getSuggestionSubtitle: function getSuggestionSubtitle(suggestion) {
                if(suggestion.user.full_name) {
                    return suggestion.user.company.company_name || suggestion.user.email;
                }
            },

            goToTrackTab: function goToTrackTab() {
                this.$state.go(this.AppStates.root_core_navigation_invite_track);
            },

            goToReferTab: function goToReferTab() {
                this.$state.go(this.AppStates.root_core_navigation_invite_referrals);
            },

            onTagAdded: function onTagAdded($tag) {
                //remove from suggestions array
                this.suggestions = this._.reject(this.suggestions, function (suggestion) {
                    return suggestion.user.email === $tag.text;
                });
            },

            arrangeSuggestionCards: function arrangeSuggestionCards() {
                // use timeout to make sure that this runs after the page renders
                this.$timeout(function () {
                    var cardElementLeftPosition = 0;

                angular.forEach(angular.element(".referrals-content__suggestions-card:not(.card-hidden)"), function(val, i){
                    var cardElement = angular.element(val);
                    var cardElementMargin = 30;
                    cardElementLeftPosition = cardElement.innerWidth() + cardElementMargin;
                    cardElement.css('left', cardElementLeftPosition * i + 'px');
                });

                    var suggestionsContainerElement = angular.element(".referrals-content__suggestions-wrapper");
                    var maxDisplayedCards = this.googleContactsIntegrationActive ? 4 : 3;
                    var numDisplayedCards = Math.min(maxDisplayedCards, this.suggestions.length);
                    var containerWidth = numDisplayedCards * cardElementLeftPosition - 2;
                    suggestionsContainerElement.css('width', containerWidth);
                }.bind(this), 0, false);
            },

            isDoodle: function isDoodle(name) {
                return this.DoodleService.isDoodle(name);
            },

            onUpdatePersonalInviteMessage: function onUpdatePersonalInviteMessage() {
                this.personalMessageIsMissingLink = false;
                this.MemberReferralsManager.updatePersonalInviteMessage(this.campaignDetails, this.referralEmailMessage);
            }
        }
    );
}());
